import { render } from "./Contact.vue?vue&type=template&id=5503d282&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=5503d282&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5503d282"

export default script